import apiClient from '@/services/AccountClient'

const state = () => ({
  currencyList: [],
  currencyListLoaded: false
})

const getters = {
  currencyList: (state) => {
    return state.currencyList
  },
  currencyOptions: (state) => {
    return state.currencyList.map(currency => ({
      name: currency,
      value: currency
    }))
  },
  currencyListLoaded: (state) => {
    return state.currencyListLoaded
  }
}

const actions = {
  loadCurrencyList ({ commit }) {
    return apiClient.sendRequest(
      'GET',
      'api/admin/v1/accounts/balances/currencies'
    )
      .then(({ payload }) => {
        commit('setCurrencyList', payload)
        commit('setCurrencyListLoaded')
      })
  }
}

const mutations = {
  setCurrencyList (state, currencyList) {
    state.currencyList = currencyList
  },
  setCurrencyListLoaded (state) {
    state.currencyListLoaded = true
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
